import React from 'react';

const initContext = {
  dataForm: {
    data: null, key: '', message: '', formResponses: [],
    hiddenFields: [], disabledFields: {}, model: {}
  },
  formStatus: { steps: [], currentStep: 0, currentQuestion: 0, numberQuestionsStep: 0 },
  product: '',
  returnButton: false,
  price: '',
  priceToShow: '',
  responseCotizacion: {},
  showFinalMessage: { visible: true, title: '', message: '', number: '', visibleError: false },
  showAlert: { messagge: '', type: '' },
  backgroundServiceResponse: {},
  folio: '',
  homePageData: {},
  showHomePage: true,
  modality: "",
  selectedPeriodicity: 12,
  responseRequest: { cotizacion: [], emision: [] },
  isSendForm: false,
  progressStep: [],
  loadingProcedure: false,
  loadingComponent: { visible: true, active: false },
  sidebarData: [],
  activeKey: '',
  insureds: [],
  checked: false,
  isClassActive: {},
  isActive: {},
  policyNumber: "",
  valuesMap: {},
  currency: true,
  isActiveAditionals: { TEV: true, FHM: true },
  additionalCoverages: [],
  typePerson: {},
  isValidPerson: false,
  checkOption:'',
  setCheckOption : () => { },
  setIsValidPerson : () => { },
  setTypePerson : () => { },
  setAdditionalCoverages: () => { },
  setIsActiveAditionals: () => { },
  setCurrency: () => { },
  setValuesMap: () => { },
  setIsClassActive: () => { },
  setChecked: () => { },
  setActiveKey: () => { },
  setSidebarData: () => { },
  setLoadingComponent: () => { },
  setProduct: () => { },
  setDataForm: () => { },
  setFormStatus: () => { },
  setReturnButton: () => { },
  setPrice: () => { },
  setPriceToShow: () => { },
  setResponseCotizacion: () => { },
  setShowFinalMessage: () => { },
  setShowAlert: () => { },
  setBackgroundServiceResponse: () => { },
  setFolio: () => { },
  setSelectedPeriodicity: () => { },
  setHomePageData: () => { },
  setShowHomePage: () => { },
  setModality: () => { },
  setIsSendForm: () => { },
  setProgressStep: () => { },
  setResponsesRequest: () => { },
  setLoadingProcedure: () => { },
  setInsureds: () => { },
  setIsActive: () => { },
  setPolicyNumber: () => { }
};

const Context = React.createContext(initContext);

export const Provider = Context.Provider;

export default Context;
